import axios, { HttpStatusCode } from "axios";
import { defaultHeader } from "../constants/defaultItems";
import { toast } from "@/components/ui/use-toast";
const BaseAPIUrl = "/api/UserAccount/";
// export const getMyProfile = (callback) => (dispatch) => {
//   axios.get(BaseAPIUrl + "GetMyProfile", defaultHeader).then((resp) => {
//     if (resp.status == HttpStatusCode.Ok) {
//       let response = resp.data;
//       if (response.IsSuccess) {
//         callback && callback(response.Result);

//       } else {
//         toast({
//           variant: "destructive",
//           title: "Failed",
//           description: response.Message ?? "Something went wrong",
//         });
//       }
//     }
//   });
// };

export const getMyProfile = (callback) => (dispatch) => {
  axios.get(BaseAPIUrl + "GetMyProfile", defaultHeader).then((resp) => {
    if (resp.status == HttpStatusCode.Ok) {
      if (resp.data.IsSuccess)
        callback && callback(resp.data.Result);
      else
        toast({
          variant: "destructive",
          title: "Failed",
          description: resp.data.Message ?? "Something went wrong",
        });
    }
  });
};
export const updateProfile = (data, callback) => (dispatch) => {
  axios
    .post(BaseAPIUrl + "UpdateMyProfile", data, defaultHeader)
    .then((response) => {
      console.log("response", response);
    });
};

export const changePassword = (data, callback) => (dispatch) => {
  axios
    .post(BaseAPIUrl + "ChangeMyPassword", data, defaultHeader)
    .then((response) => {
      if (response.status == HttpStatusCode.Ok) {
        if (response.data.IsSuccess) {
          callback && callback(true);
          toast({
            variant: "success",
            title: "Success",
            description: response.data.Message,
          });
        } else {
          toast({
            variant: "destructive",
            title: "Failed",
            description: response.data.Message,
          });
        }
      }
      console.log("response from change password", response);
    });
};
